import { render, staticRenderFns } from "./synthesize-form.html?vue&type=template&id=0b5eec71&scoped=true&external"
import script from "./synthesize-form.js?vue&type=script&lang=js&external"
export * from "./synthesize-form.js?vue&type=script&lang=js&external"
import style0 from "./synthesize-form.scss?vue&type=style&index=0&id=0b5eec71&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5eec71",
  null
  
)

export default component.exports